import { forwardRef } from 'react'
import { Box, BoxProps } from '@pancakeswap/uikit'

const Container = forwardRef<HTMLDivElement, React.PropsWithChildren<BoxProps>>(({ children, ...props }, ref) => (
  <Box ref={ref} px={['16px', '24px']} mx="auto" maxWidth="1250px" {...props}>
    {children}
  </Box>
))

export default Container
